import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";

import { AlertService, ShowroomService } from "../../_services";
import { Utils } from "../../_helpers";

@Component({ templateUrl: "showroom.add.html" })
export class ShowroomAdd implements OnInit {
  heading = "Add Showroom";
  subheading = "";
  icon = "fa fa-folder-o icon-gradient bg-happy-itmeo";
  showroomForm: FormGroup;
  loading = false;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private showroomService: ShowroomService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.showroomForm = this.formBuilder.group({
      showroom_name: ["", [Validators.required, Utils.noWhitespaceValidator]],
      showroom_status: ["A", [Validators.required, Utils.noWhitespaceValidator]]
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.showroomForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.showroomForm.invalid) {
      return;
    }

    this.loading = true;

    const formData = new FormData();
    formData.append(
      "showroom_name", this.showroomForm.get("showroom_name").value
    );
    formData.append("status", this.showroomForm.get("showroom_status").value);

    this.showroomService
      .insert(formData)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data.status == "ok") {
            this.alertService.success(data.message, true);
            this.router.navigate(["/showroom"]);
          } else {
            this.alertService.error(data.message, true);
            this.loading = false;
          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        }
      );
  }
}
